let productThumbsSlider = new Swiper(".mySwiper", {
  spaceBetween: 20,
  slidesPerView: 6,
  direction: 'vertical',
  freeMode: true,
  cssMode:true,
  watchSlidesProgress: true,
});
let productMediaSlider = new Swiper(".mySwiper2", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  a11y: {
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
  },
  thumbs: {
    swiper: productThumbsSlider,
  },
});

{
var productForm = document.querySelector("form.product__form");
{
  const _qtyTarget = document.querySelector('form input[name="quantity"]');
  const _qtySource = document.querySelector('.quantity__input');
  if (_qtyTarget && _qtySource) { _qtyTarget.value = _qtySource.value; }
}

productForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  const addButton = document.querySelector('button.main-product-add');
  addButton.classList.add('loading');
  const formData = Object.fromEntries(new FormData(event.currentTarget));
  const domParser = new DOMParser();
  try{
    fetch(`${routes.cart_add_url}`, {method: "POST",credentials: "same-origin",headers: {"Content-Type": "application/json","X-Requested-With": "XMLHttpRequest",},body: JSON.stringify(formData),})
    .then(function(response){return response.json()})
    .then((response) =>  {
      const url = document.querySelector('.section-mini-cart').id.replace('shopify-section-','');
      fetch(`${Shopify.routes.root}?section_id=${url}`)
      .then(res=>res.text())
      .then(data=>{
            const footerCart = domParser.parseFromString(data, 'text/html').querySelector(`.section-mini-cart .min-cart-footer`);
            document.querySelector(`.section-mini-cart .min-cart-footer`).innerHTML = footerCart.innerHTML;
            const htmlCard = domParser.parseFromString(data, 'text/html').querySelector(`.section-mini-cart .cart-items-list`);
            document.querySelector(`.section-mini-cart .cart-items-list`).innerHTML = htmlCard.innerHTML;
            const itemsCount = domParser.parseFromString(data, 'text/html').querySelectorAll(`.section-mini-cart cart-item`);
            addButton.classList.remove('loading');
            if(itemsCount.length > 0){
              
              document.querySelector(`.section-mini-cart div.min-cart-footer`).style.display="flex";
              document.querySelector('.mini-cart-bubble').textContent = htmlCard.getAttribute('data-count');
            }
            else{
              document.querySelector('.mini-cart-bubble').textContent = '0'
            }
            if(response.status === 422) {
              const existingErrorElement = document.querySelector('.main-product-quantity-wrapper p.error-message');
              if(existingErrorElement) return;
              const errorElement = document.createElement('p');
              errorElement.classList.add('error-message');
              errorElement.innerHTML = response.description;
              document.querySelector('.main-product-quantity-wrapper').appendChild(errorElement);
              return;
            }
            hideOverlays();
            document.querySelector('[href="/cart"]').click();
            document.querySelector('input.quantity__input').value = 1
      }) 
    });
  }
  catch(e){
    addButton.classList.remove('loading');
    console.log(e);
  }
});

function hideOverlays(){
  const quickAddWrapper = document.querySelector('.quick-add-wrap');
  const quickAddOverlay = document.querySelector('.quick-add-overlay');
  const quickViewWrapper = document.querySelector('.quick-view-wrap');
  const quickViewWrapperOverlay = document.querySelector('.quick-view-overlay');
  [quickAddWrapper,quickAddOverlay,quickViewWrapper,quickViewWrapperOverlay].forEach(item=>{
    if(!item) return;
    item.classList.remove('visible')
  })
}


if (!customElements.get('variant-selects')) {
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.shouldUpdateUrl = Boolean(this.getAttribute("data-update-url")); 
    this.colorIndex = Number(this.getAttribute("data-color-index"));   
    this.addEventListener("change", this.validateVariant);
    this.productVariants = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.validateVariant();
  }
  validateVariant() {
    const form = this.closest(".main-product").querySelector('form');
    const productWrapper = this.closest(".main-product");
    let selectedValues = [];
    const domParser = new DOMParser();
    const allVariants =
    productWrapper.querySelectorAll("select.option-variants").length > 0
        ? productWrapper.querySelectorAll("select.option-variants")
        : productWrapper.querySelectorAll("input.option-variants:checked");
    allVariants.forEach((variant) => selectedValues.push(variant.value));

    function findMatchingObject(selectedValues, productVariants) {
      for (const variant of productVariants) {
        if (matchesSelectedValues(variant, selectedValues)) {
          return variant;
        }
      }
      return null;
    }

    function matchesSelectedValues(variant, selectedValues) {
      for (let i = 0; i < selectedValues.length; i++) {
        if (variant[`option${i + 1}`] !== selectedValues[i]) {
          return false;
        }
      }
      return true;
    }

    function updateBrowserUrlWithVariantId(variantId) {
      const newUrl =
        window.location.origin +
        window.location.pathname +
        "?variant=" +
        variantId;
      window.history.pushState({ path: newUrl }, "", newUrl);
    }

    function updateVariantId(variantId) {
      if (!variantId) return;
      const idField = form ? form.querySelector('[name="id"]') : null;
      if (idField) idField.value = variantId.id;
    }

    let updatedMedia = (selectedVariant) => {
      if (!selectedVariant || !selectedVariant.featured_media) return;
      const variantMediaId = selectedVariant.featured_media.id;
      const activeSlide = document.querySelector(`#media-${variantMediaId}`);
      if (!activeSlide || typeof productMediaSlider === 'undefined') return;
      // index of the matching slide within the main media slider
      const slides = Array.from(activeSlide.parentElement.children);
      const index = slides.indexOf(activeSlide);
      if (index > -1) productMediaSlider.slideTo(index);
    }

    function removeErrors(){
      const existingErrorElement = document.querySelectorAll('p.error-message');
      if(existingErrorElement.length < 1) return;
      existingErrorElement.forEach((element) => element.remove());
    }

    function updateMaxValueOfQuantitySelector(variantId) {
      if(!window.variantsInventory) return;
      const productQuanityField = document.querySelector("input.quantity__input");

    }

    function updateAddButton(selectedVariant) {
      let addButton = form ? form.querySelector('button.main-product-add') : null;
      if (!addButton || !selectedVariant) return;
      addButton.disabled = !selectedVariant.available;
      addButton.innerHTML = selectedVariant.available
        ? "<span>ADD TO CART</span>"
        : "<span>Sold out</span>";
    }

    function updateSoldoutVariants(selectedVariant, productVariants) {
      productVariants.map((variant) => {
        if (
          variant.option1 === selectedVariant.option1 &&
          selectedValues.length > 1
        ) {
          if (variant.option2 && variant.option3) {
            if (selectedVariant.option2 === variant.option2) {
              variant.available
                ? (productWrapper.querySelector(
                    `[value="${variant.option3}"]`
                  ).disabled = false)
                : (productWrapper.querySelector(
                    `[value="${variant.option3}"]`
                  ).disabled = true);
            }
          } else if (variant.option2 && !variant.option3) {
            variant.available
              ? (productWrapper.querySelector(
                  `[value="${variant.option2}"]`
                ).disabled = false)
              : (productWrapper.querySelector(
                  `[value="${variant.option2}"]`
                ).disabled = true);
          }
        } else if (
          variant.option1 !== selectedVariant.option1 &&
          selectedValues.length === 1
        ) {
          variant.available
            ? (productWrapper.querySelector(
                `[value="${variant.option1}"]`
              ).disabled = false)
            : (productWrapper.querySelector(
                `[value="${variant.option1}"]`
              ).disabled = true);
        }
      });
    }

    const selectedVariant = findMatchingObject(
      selectedValues,
      this.productVariants
    );

    updateVariantId(selectedVariant);
    updateAddButton(selectedVariant);
    updateSoldoutVariants(selectedVariant, this.productVariants);
    updatedMedia(selectedVariant, this.productVariants);
    updateMaxValueOfQuantitySelector(selectedVariant);
    removeErrors()
  }
}
customElements.define("variant-selects", VariantSelects);
} 
let productQuanityField = document.querySelector("input.quantity__input");
let productPlusButton = document.querySelector("button.quantity__button.quantity-plus");
let productMinusButton = document.querySelector("button.quantity__button.quantity-minus");
let productFormQuantity = document.querySelector("form.product__form [name='quantity']");
productPlusButton?.addEventListener("click", incrementQuantity)
productMinusButton?.addEventListener("click", decrementQuantity)

function incrementQuantity(e) {
  let current = Number(productQuanityField.value);
  let step= Number(productQuanityField.getAttribute('step'));
  let max= Number(productQuanityField.getAttribute('max'));
  let newval = (current + step);
  if(newval > max) newval = max;
  productQuanityField.value = Number(newval);
  productFormQuantity.value = Number(newval);
  e.preventDefault();
}
function decrementQuantity(e) {
  let step= Number(productQuanityField.getAttribute('step'));
  let current = Number(productQuanityField.value);
  let min= Number(productQuanityField.getAttribute('min'));
  let max= Number(productQuanityField.getAttribute('max'));
  let newval = (current - step);
  if(newval < min) {
    newval = min;
  } else if(newval > max) {
    newval = max;
  } 
  productQuanityField.value = Number(newval);
  productFormQuantity.value = Number(newval);
  e.preventDefault();
}

productQuanityField.addEventListener('keyup', function() {
  var inputValue = Number(productQuanityField.value);
  var maxValue = Number(productQuanityField.getAttribute('max'));

  if (inputValue < 1) {
    productQuanityField.value = 1;
  }
  else if(inputValue > maxValue){
    productQuanityField.value = maxValue;
  }
 else{
  productFormQuantity.value = Number(inputValue);
 }
});}